<template>
  <div class="emd-container _highlight_header no-border">
    <div class="emd-container__header headerMobile">
      <div class="eu-pa_2">
        <div class="eu-flex eu-mb_3">
          <div class="emd-text _size_default">
            {{ $t('charge.detail.recipients.title') }}
          </div>
          <router-link
            :to="{ name: 'recipientsDetail', params: { id: idRecipient } }"
            exact
            class="emd-link _color_secondary"
          >
            <span class="emd-text _size_default _type_caption">
              &nbsp; {{ name }}
            </span>
          </router-link>
        </div>
        <div class="eu-flex eu-fluid_custom_tag">
          <div
            v-if="liable"
            class="contentTag"
          >
            <span class="emd-badge tag">{{
              $t('charge.detail.recipients.responsability-chargeback')
            }}</span>
          </div>
          <div
            v-if="chargeProcessingFee"
            class="contentTag"
          >
            <span class="emd-badge tag">{{
              $t('charge.detail.recipients.responsability-MDR')
            }}</span>
          </div>
        </div>
      </div>
      <!-- web -->
      <div class="eu-mr_5 desktopRow">
        <div
          :id="`netAmount-${idRecipient}`"
          class="emd-text totalLiquid"
          v-if="netAmount"
        >
          {{ $t('charge.detail.recipients.nets-amount') }}
          <span class="emd-text _type_caption">{{ netAmount }}</span>
        </div>
        <div class="emd-text sizeRuleSplit">
          {{ $t('charge.detail.recipients.rule-split') }}
          <span class="emd-text sizeRuleSplit _type_caption">{{ amount }}</span>
        </div>
      </div>
      <!-- mobile -->
      <div class="eu-flex mobileRow">
        <div
          class="eu-ml_2 eu-mr_4"
          v-if="netAmount"
        >
          <div class="emd-text _color_subtle _type_caption eu-mb_1">
            {{ $t('charge.detail.recipients.nets-amount') }}
          </div>
          <span class="emd-text">{{ netAmount }}</span>
        </div>
        <div :class="!netAmount && 'eu-ml_2'">
          <div class="emd-text _color_subtle _type_caption eu-mb_1">
            {{ $t('charge.detail.recipients.rule-split') }}
          </div>
          <span class="emd-text _size_default">{{ amount }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecipientHeader',
  props: {
    amount: {
      type: String,
      required: true
    },
    liable: {
      type: Boolean
    },
    chargeProcessingFee: {
      type: Boolean
    },
    netAmount: {
      type: String
    },
    idRecipient: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  }
}
</script>
<style>
.no-border {
  border: none;
}
.totalLiquid {
  font-weight: 700;
  font-size: 20px;
  margin-bottom: 8px;
}

.contentTag {
  margin-right: 8px;
}

.sizeRuleSplit {
  font-size: 16px;
}

.tag {
  background-color: var(--color-white);
  border: 2px solid var(--color-border-grey);
}

.mobileRow {
  display: none;
}

@media only screen and (max-width: 862px) {
  .desktopRow {
    margin-top: 12px;
  }
}

@media screen and (max-width: 768px) {
  .tag {
    margin-top: 8px;
  }

  .eu-fluid_custom_tag {
    flex-direction: column;
  }

  .desktopRow {
    display: none;
  }

  .headerMobile {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .mobileRow {
    display: flex;
    margin-top: 12px;
  }
}
</style>
